import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-257f8b57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchable-dropdown" }
const _hoisted_2 = ["value", "placeholder"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dropdown-arrow" }, "▼", -1))
const _hoisted_4 = {
  key: 0,
  class: "dropdown-content"
}
const _hoisted_5 = ["onClick"]

import {
  ref,
  computed,
  onMounted,
  onUnmounted,
} from "vue";

interface Option {
  value: string | number;
  label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchableDropdown',
  props: {
    modelValue: {},
    options: {},
    placeholder: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const searchQuery = ref("");

const displayValue = computed(() => {
  const selectedOption = props.options.find(
    (opt) => opt.value === props.modelValue
  );
  return selectedOption ? selectedOption.label : "";
});

const filteredOptions = computed(() => {
  return props.options
    .filter((option) =>
      option.label.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
    .sort((a, b) => a.label.localeCompare(b.label));
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const handleSearch = (event: Event) => {
  const input = event.target as HTMLInputElement;
  searchQuery.value = input.value;
  isOpen.value = true;
};

const selectOption = (option: Option) => {
  emit("update:modelValue", option.value);
  isOpen.value = false;
  searchQuery.value = "";
};

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  if (!target.closest(".searchable-dropdown")) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "dropdown-header",
      onClick: toggleDropdown
    }, [
      _createElementVNode("input", {
        type: "text",
        value: displayValue.value,
        placeholder: _ctx.placeholder,
        onInput: handleSearch,
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        class: "search-input"
      }, null, 40, _hoisted_2),
      _hoisted_3
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              key: option.value,
              class: _normalizeClass(["dropdown-option", { selected: _ctx.modelValue === option.value }]),
              onClick: ($event: any) => (selectOption(option))
            }, _toDisplayString(option.label), 11, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})